import { ServiceError } from '@omnea-digital/serverless-toolbox'
import { useMutation } from '@tanstack/react-query'
import { enqueueSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { DuplicateRequestBody, DuplicateRequestResponse } from '@omnea-app/requests/requestsFrontendClient'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export const useDuplicateRequest = ({ requestId }: { requestId: string }) => {
  const { getToken } = useAuthenticatedUser()
  const { t } = useTranslation('requests')

  return useMutation<DuplicateRequestResponse, Error, { body: DuplicateRequestBody }>({
    mutationFn: async ({ body }) => {
      const token = await getToken()
      const apiClient = new RequestsHttpClient({ authorization: token })
      const { data, error } = await apiClient.POST('/{id}/duplicate-request', {
        params: { path: { id: requestId } },
        body,
      })
      throwIfApiError(error)
      return data
    },
    onError: async (error: ServiceError | Error) => {
      if ('type' in error && error.type === 'DuplicateRequestFormMismatchError') {
        enqueueSnackbar(`${t('duplication-modal.error-intake-form-changed')}`, { variant: 'error', autoHideDuration: 3000 })
      } else {
        enqueueSnackbar(`${t('duplication-modal.error')}`, { variant: 'error', autoHideDuration: 3000 })
      }
    },
  })
}
